﻿import type { SupportedSoftware } from "@domain/repositories/ISoftwareVersionsRepository";

/**
Per-engine license availability, derived from the cluster by the backend.
*/
export interface LicenseStatus {
  known: boolean;
  spectronautLicensed: boolean;
  spectroMineLicensed: boolean;
}

export interface ILicenseRepository {
  saveLicense(licenseKey: string, software?: SupportedSoftware): Promise<void>;
  getStatus(): Promise<LicenseStatus>;
}
